import { RouteType } from "types/RouteType";
import aiAgentRoute from "./AIAgent/AIAgent.Route";
import dashboardRoute from "./Dashboard/dashboard.Route";
import departmentsRoute from "./Departments/departments.Route";
import permissionsRoute from "./Permissions/permissions.Route";
import standardProceduresRoute from "./StandardProcedures/standardProcedures.Route";
import userManagementRoute from "./UserManagement/userManagement.Route";

const administrationRoutesList: RouteType[] = [
    ...aiAgentRoute,
    ...dashboardRoute,
    departmentsRoute,
    ...permissionsRoute,
    standardProceduresRoute,
    ...userManagementRoute,
];

export default administrationRoutesList;
